import { Component, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import {Router} from "@angular/router";
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-search',
    templateUrl: './kaz-search.component.html',
    styleUrls: ['./kaz-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, FaIconComponent]
})
export class KazSearchComponent {
  private _router = inject(Router);

  @Input() value: string = "";
  @Input() placeholder: string = "Wonach suchen Sie? | z.B Chiffre-Nr.";

  search(search: string) {
    this._router.navigate(['/entry/search'], {queryParams: {search: search}}).then();   }

  showFilter() {
    this._router.navigate(['/entry/search']).then();

  }
}
